(function () {
  'use strict';

  // Mobile menu
  var burger = document.querySelector('[data-menu-open]');
  var menu = document.querySelector('[data-mobile-menu]');
  var closeBtn = document.querySelector('[data-menu-close]');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      menu.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (closeBtn && menu) {
    closeBtn.addEventListener('click', function () {
      menu.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }

  // Quantity steppers
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    if (!input) return;
    var step = parseInt(btn.getAttribute('data-qty-step'), 10);
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Product page: variant selection by option radios
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var dataEl = document.querySelector('[data-product-json]');
    var product = dataEl ? JSON.parse(dataEl.textContent) : null;
    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');
    var errorEl = form.querySelector('[data-error]');

    var currentVariant = function () {
      if (!product) return null;
      var selected = [];
      form.querySelectorAll('[data-option-group]').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return selected[i] === null || o === selected[i]; });
      });
    };

    var update = function () {
      var v = currentVariant();
      if (!v) {
        addBtn.disabled = true;
        addBtn.textContent = 'Niedostępne';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? addBtn.getAttribute('data-label-add') : addBtn.getAttribute('data-label-soldout');
      if (priceEl && v.price_formatted) {
        priceEl.innerHTML = v.price_formatted;
      }
      var lowEl = document.querySelector('[data-low-stock]');
      if (lowEl) lowEl.hidden = !v.low_stock;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };

    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-option-group]')) update();
    });

    // Add to cart via AJAX, then go to cart
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.disabled = true;
      var original = addBtn.textContent;
      addBtn.textContent = 'Dodawanie…';
      if (errorEl) errorEl.textContent = '';
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(form.querySelector('[name="quantity"]').value, 10) || 1 }]
        })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Błąd');
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (err) {
          if (errorEl) errorEl.textContent = err.message;
          addBtn.disabled = false;
          addBtn.textContent = original;
        });
    });

    update();
  }

  // Cart page: auto-submit on quantity change
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    cartForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-cart-qty]')) cartForm.submit();
    });
  }
})();
